'use client';

import { useProductPriceData } from 'app/[lang]/[esite]/(core)/(search-display)/hooks/useProductPriceData';
import ProductCardSpecifications from 'components/product-comparison-grid/product-comparison-card/product-card-specifications';

interface ProductCardSpecificationsWrapperProps {
  productNumber: string;
  index: number;
  products: Product[];
  serialNumber: string;
  isProductSpecsMobileDrawerEnabled: boolean;
  manufacturer: string;
  unitOfMeasure: string;
  attributes: Attribute[];
  locationId: string;
  isRegistrationPendingApproval: boolean;
}
const ProductCardSpecificationsWrapper = (
  props: ProductCardSpecificationsWrapperProps
) => {
  const { productNumber, index, products, serialNumber } = props;
  const { productPriceData } = useProductPriceData({
    productNumber,
    index,
    products,
    serialNumber
  });

  return (
    <ProductCardSpecifications {...props} productPriceData={productPriceData} />
  );
};

export default ProductCardSpecificationsWrapper;
